import { BulkUpdateRequest } from "api/data";

import { ColumnData } from "../fieldGroupAtoms";

/**
 * Get cell updates for newly added columns
 */
export function getNewColumnCells(
  columns: ColumnData[],
  uwis: string[],
  initialColumns: ColumnData[]
): BulkUpdateRequest["updates"] {
  const updates: BulkUpdateRequest["updates"] = [];

  columns.forEach((col) => {
    const isNewColumn = !initialColumns.some((ic) => ic.name === col.name);
    if (!isNewColumn) return;

    uwis.forEach((uwi) => {
      const value = col.data[uwi];
      if (value) {
        updates.push({ propertyName: col.propertyName, uwi, value });
      }
    });
  });

  return updates;
}

/**
 * Convert tracked changes map to update requests
 */
export function getChangedCellsFromMap(
  changedCells: Map<string, Map<string, string>>
): BulkUpdateRequest["updates"] {
  const updates: BulkUpdateRequest["updates"] = [];

  changedCells.forEach((uwiMap, propertyName) => {
    uwiMap.forEach((value, uwi) => {
      updates.push({ propertyName, uwi, value });
    });
  });

  return updates;
}

/**
 * Add multiple cell changes to the change tracking map (for paste, batch edits)
 */
export function addCellsToChangeMap(
  currentMap: Map<string, Map<string, string>>,
  changes: Array<{ propertyName: string; uwi: string; value: string }>
): Map<string, Map<string, string>> {
  const next = new Map(currentMap);
  // Track which property maps we've already copied to avoid redundant copies
  const copiedProperties = new Set<string>();

  changes.forEach(({ propertyName, uwi, value }) => {
    if (!next.has(propertyName)) {
      next.set(propertyName, new Map());
      copiedProperties.add(propertyName);
    } else if (!copiedProperties.has(propertyName)) {
      next.set(propertyName, new Map(next.get(propertyName)));
      copiedProperties.add(propertyName);
    }

    const uwiMap = next.get(propertyName);
    if (uwiMap) {
      uwiMap.set(uwi, value);
    }
  });

  return next;
}
